import React from "react";
import { ProgressSaved } from "../../progressSaved";
import { TimestampLabel } from "../../timestampLabel";
import { PublishedStatusTypes } from "../../../enums";
import { type PublishedStatusType } from "../../../enums/publishedStatusTypes";

import "./sectionSubHeader.scss";
import { ReportLastUpdated } from "features/Reporting/Content/shared/ReportLastUpdated";

export interface Props {
  publishedStatus: PublishedStatusType;
  lastModifiedDateTime: Date | undefined | string;
  isUpdateInProgress: boolean;
  children: React.ReactNode;
  showReportLastUpdated: boolean;
}

function SectionSubHeader(props: Props) {
  const { children, publishedStatus, lastModifiedDateTime, isUpdateInProgress, showReportLastUpdated } = props;

  return (
    <div className="section-sub-header">
      {children}
      {lastModifiedDateTime && (
        <ProgressSaved
          timestampLabel={
            <TimestampLabel
              label={publishedStatus === PublishedStatusTypes.published ? "Last Modified" : "Last Saved"}
              dateTime={lastModifiedDateTime}
              format="MM/DD/YYYY h:mm A"
            />
          }
          inProgress={isUpdateInProgress}
        />
      )}
      {showReportLastUpdated && (
        <div className="report-last-updated">
          <ReportLastUpdated />
        </div>
      )}
    </div>
  );
}

export default SectionSubHeader;
